import {inject, Injectable} from '@angular/core';
import {ErrorService} from "../error/error.service";
import {BicToastService} from "@buildinginformationcloud/bic-ui-components";

const MAX_TOASTS = 2;
const TOAST_DURATION_MS = 5000;

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private errorService = inject(ErrorService);
  private bicToastService = inject(BicToastService);
  private activeToasts: string[] = [];


  constructor() {

    this.errorService.errorEvent$.pipe().subscribe(error => {
      if (error.url?.includes("state") && error.status === 0) {
        this.showErrorMessage("Keine Verbindung zum Server. Bitte überprüfen Sie Ihre Internetverbindung.");
      }
    });
  }


  private showToast(id: string): void {
    while (this.activeToasts.length >= MAX_TOASTS) {
      const oldest = this.activeToasts.shift();
      if (oldest !== undefined) {
        this.bicToastService.dismiss(oldest);
      }
    }
    this.activeToasts.push(id);
    setTimeout(() => {
      this.bicToastService.dismiss(id);
      const idx = this.activeToasts.indexOf(id);
      if (idx !== -1) {
        this.activeToasts.splice(idx, 1);
      }
    }, TOAST_DURATION_MS);
  }

  public showErrorMessage(message: string): void {
    this.showToast(this.bicToastService.error(message));
  }

  public showSuccessMessage(message: string): void {
    this.showToast(this.bicToastService.success(message));
  }

  public showInfoMessage(message: string): void {
    this.showToast(this.bicToastService.info(message));
  }

  public showWarningMessage(message: string): void {
    this.showToast(this.bicToastService.warning(message));
  }

}
